import { TFunction } from 'i18next'

import { PaymentReminderDetailsRepeatType } from '../../../enums/paymentReminderDetailsRepeatType'

export const getAfterDueDateSelectItems = (t: TFunction) => {
  return [
    {
      id: PaymentReminderDetailsRepeatType.Once,
      value: PaymentReminderDetailsRepeatType.Once,
      children: t(
        'settings.organization.external_invoice.automatic_payment_reminders.modal.form.repeat_select_option.once',
      ),
    },
    {
      id: PaymentReminderDetailsRepeatType.Every,
      value: PaymentReminderDetailsRepeatType.Every,
      children: t(
        'settings.organization.external_invoice.automatic_payment_reminders.modal.form.repeat_select_option.every',
      ),
    },
  ]
}
